exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-notification-dialog[data-v-42f20e10]{position:fixed;bottom:0;right:0;width:50%;max-width:500px;min-width:300px}.flash-enter-active[data-v-42f20e10],.flash-leave-active[data-v-42f20e10]{-webkit-transition:all 1s;transition:all 1s}.flash-enter[data-v-42f20e10],.flash-leave-to[data-v-42f20e10]{opacity:0;-webkit-transform:translateY(100px);transform:translateY(100px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42f20e10","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ckFlash.vue
// module id = rKsP
// module chunks = 0